import React from 'react';
import Dropdown from 'react-dropdown';
//import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import { SketchPicker } from 'react-color';
//import { CustomizeCard } from '../../components';
import { PostToggleCard, CmnCustomizeCard } from '../../components';

//animition for desktop
const Animation = [
  { value: 'fade', label: 'Fade' },
  { value: 'bounce', label: 'Bounce' },
  { value: 'zoom', label: 'Zoom' },
  { value: 'zoom_in_down', label: 'Zoom In Down' },
  { value: 'slide', label: 'Slide' },
  { value: 'horizonatal_slide', label: 'Slide Horizontal' },
  { value: 'side_flip_in', label: 'Slide Flip In' },
  { value: 'side_flip_back', label: 'Slide Flip Back' },
  { value: 'flip', label: 'Flip' },
  { value: 'up_flip', label: 'Flip Up' },
  { value: 'back_flip', label: 'Flip Back' },
];

const brdSizeOption = [
  { value: '0', label: '0' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
];

const brdStylOption = [
  { value: 'solid', label: 'Solid' },
  { value: 'dashed', label: 'Dashed' },
  { value: 'dotted', label: 'Dotted' }

];

const brdRdsOption = [
  { value: '0', label: '0' },
  { value: '5', label: '5' },
  { value: '10', label: '10' },
  { value: '15', label: '15' },
  { value: '20', label: '20' },
  { value: '25', label: '25' },
  { value: '30', label: '30' },
];

const shdOption = [
  { value: '-30', label: '-30' },
  { value: '-27', label: '-27' },
  { value: '-24', label: '-24' },
  { value: '-21', label: '-21' },
  { value: '-18', label: '-18' },
  { value: '-15', label: '-15' },
  { value: '-12', label: '-12' },
  { value: '-9', label: '-9' },
  { value: '-6', label: '-6' },
  { value: '-3', label: '-3' },
  { value: '0', label: '0' },
  { value: '3', label: '3' },
  { value: '6', label: '6' },
  { value: '9', label: '9' },
  { value: '12', label: '12' },
  { value: '15', label: '15' },
  { value: '18', label: '18' },
  { value: '21', label: '21' },
  { value: '24', label: '24' },
  { value: '27', label: '27' },
  { value: '30', label: '30' },
];

const shdblrOption = [
  { value: '0', label: '0' },
  { value: '3', label: '3' },
  { value: '6', label: '6' },
  { value: '9', label: '9' },
  { value: '12', label: '12' },
  { value: '15', label: '15' },
  { value: '18', label: '18' },
  { value: '21', label: '21' },
  { value: '24', label: '24' },
  { value: '27', label: '27' },
  { value: '30', label: '30' }
];

const fontOption = [
  { value: 'lato', label: 'Lato' },
  { value: 'roboto', label: 'Roboto' },
  { value: 'raleway', label: 'Raleway' },
  { value: 'poppins', label: 'Poppins' },
  { value: ' ', label: 'Website Font' },
];

let fontSize = [
  { value: '10', label: '10px' },
  { value: '12', label: '12px' },
  { value: '13', label: '13px' },
  { value: '14', label: '14px' },
  { value: '16', label: '16px' },
  { value: '18', label: '18px' },
  { value: '20', label: '20px' },
  { value: '22', label: '22px' },
  { value: '24', label: '24px' },
  { value: '26', label: '26px' },
  { value: '28', label: '28px' },
];

let Position = [];
let MobilePosition = [];
const ChatAppearanceCard = ({
  cnf,
  handleCnfChange,
  colorPick,
  handleColorPicker,
  currLayout,
  wdtnm,
  fnCheckFieldIsDisplayOrNot
}) => {

  //for desktop position
  if (wdtnm == 'countdown_timer') {
    Position = [
      { value: 'banner_top', label: 'Top' },
      { value: 'banner_center', label: 'Center' },
      { value: 'banner_bottom', label: 'Bottom' }
    ];
  } else {
    Position = [
      { value: 'left_top', label: 'Left top' },
      { value: 'center_top', label: 'Center top' },
      { value: 'right_top', label: 'Right top' },
      { value: 'left_center', label: 'Left center' },
      { value: 'center', label: 'Center' },
      { value: 'right_center', label: 'Right center' },
      { value: 'left_bottom', label: 'Left bottom' },
      { value: 'center_bottom', label: 'Center bottom' },
      { value: 'right_bottom', label: 'Right bottom' }
    ];
  }

  //for mobile position 
  if (wdtnm == 'countdown_timer' || wdtnm == 'video_popup') {
    MobilePosition = [
      { value: 'banner_top', label: 'Top' },
      { value: 'banner_center', label: 'Center' },
      { value: 'banner_bottom', label: 'Bottom' }
    ];
  }
  else if (wdtnm == 'story_widget' || wdtnm == 'allinonechat' || wdtnm == 'whatsappchat' || wdtnm == 'feedback') {
    MobilePosition = [
      { value: 'left_top', label: 'Left top' },
      { value: 'right_top', label: 'Right top' },
      { value: 'left_bottom', label: 'Left bottom' },
      { value: 'right_bottom', label: 'Right bottom' }
    ];
  } else {
    MobilePosition = [
      { value: 'left_top', label: 'Left top' },
      { value: 'center_top', label: 'Center top' },
      { value: 'right_top', label: 'Right top' },
      { value: 'left_center', label: 'Left center' },
      { value: 'center', label: 'Center' },
      { value: 'right_center', label: 'Right center' },
      { value: 'left_bottom', label: 'Left bottom' },
      { value: 'center_bottom', label: 'Center bottom' },
      { value: 'right_bottom', label: 'Right bottom' }
    ];
  }
  return (
    <div>
      {/* <Tabs className="nf-default-tabs wg-default-editor">
      <TabList className="wg-tabs-secstyle wg-tabs-appearance">
        <Tab>Layout</Tab>
        {currLayout.ltn == 'whatsapp_chat_3' &&
          <Tab>Card</Tab>
        }
      </TabList>
      <TabPanel className="tabs-secstyle-panel tabs-panel-appearance"> */}
      {cnf && fnCheckFieldIsDisplayOrNot('position', currLayout) &&
        <div className="card card-editor card-whats-appearance card-whats-deskpoani">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Position & Animation in Desktop</label>
            <div className="customize-list">
              <PostToggleCard
                ttl={'Show'}
                fieldName={'isdsk'}
                value={cnf.isdsk}
                handleCnfChange={handleCnfChange} />

              {/* <div className="editor-field-list editor-toggle">
                <label className="label-title">Show</label>
                <label className="switch">
                  <input type="checkbox" checked={cnf.isdsk} onChange={(e) => handleCnfChange('isdsk', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div> */}
              <div className="editor-field-list editor-dropdown customize-dropdown customize-coloms dropdown-editani">
                <label>Animation</label>
                <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={Animation} value={cnf.dskanm} onChange={(e) => handleCnfChange('dskanm', e.value)} />
              </div>
              {fnCheckFieldIsDisplayOrNot('cnf.dskpos', currLayout) && cnf.dskpos != undefined &&
                <div className="editor-field-list editor-dropdown customize-dropdown customize-coloms dropdown-editposi">
                  <label>Position</label>
                  <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={Position} value={cnf.dskpos} onChange={(e) => handleCnfChange('dskpos', e.value)} />
                </div>
              }
            </div>
          </div>
        </div>
      }
      {cnf && fnCheckFieldIsDisplayOrNot('position', currLayout) &&
        <div className="card card-editor card-whats-appearance card-whats-mobipoani mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Position & Animation in Mobile</label>
            <div className="customize-list">
              <PostToggleCard
                ttl={'Show'}
                fieldName={'ismbl'}
                value={cnf.ismbl}
                handleCnfChange={handleCnfChange} />

              {/* <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                <label className="label-title">Show</label>
                <label className="switch">
                  <input type="checkbox" checked={cnf.ismbl} onChange={(e) => handleCnfChange('ismbl', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div> */}
              <div className="editor-field-list editor-dropdown customize-dropdown customize-coloms dropdown-editani">
                <label>Animation</label>
                <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={Animation} value={cnf.mblanm} onChange={(e) => handleCnfChange('mblanm', e.value)} />
              </div>
              {fnCheckFieldIsDisplayOrNot('cnf.mblpos', currLayout) && cnf.mblpos != undefined &&
                <div className="editor-field-list editor-dropdown customize-dropdown customize-coloms dropdown-editposi">
                  <label>Position</label>
                  <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={MobilePosition} value={cnf.mblpos} onChange={(e) => handleCnfChange('mblpos', e.value)} />
                </div>
              }
            </div>
          </div>
        </div>
      }

      {cnf && !fnCheckFieldIsDisplayOrNot('position', currLayout) &&
        <div className="card card-editor card-whats-appearance card-whats-mobipoani mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Display on</label>
            <div className="customize-list">
              {cnf.isdsk != undefined &&
                <PostToggleCard
                  ttl={'Desktop'}
                  fieldName={'isdsk'}
                  value={cnf.isdsk}
                  handleCnfChange={handleCnfChange} />

                // <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                //   <label className="label-title">On desktop</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.isdsk} onChange={(e) => handleCnfChange('isdsk', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }
              {cnf.ismbl != undefined &&
                <PostToggleCard
                  ttl={'Mobile'}
                  fieldName={'ismbl'}
                  value={cnf.ismbl}
                  handleCnfChange={handleCnfChange} />

                // <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow mb-0">
                //   <label className="label-title">On mobile</label>
                //   <label className="switch">
                //     <input type="checkbox" checked={cnf.ismbl} onChange={(e) => handleCnfChange('ismbl', e.target.checked)} />
                //     <span className="slider round"></span>
                //   </label>
                // </div>
              }
            </div>
          </div>
        </div>
      }

      {/* Background */}
      {(cnf.tlsbg != undefined || cnf.tlshdrbg != undefined || cnf.tlsicnbg != undefined || cnf.tlsmmbrbg != undefined || cnf.tlstmcuntrbg != undefined) &&
        <div className="card card-editor card-whats-appearance card-whats-bgpop mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Background</label>
            <div className="customize-list">
              {currLayout.ltn !== 'whatsapp_chat_1' && currLayout.ltn !== 'allinonechat_2' && cnf.tlsbg != undefined &&
                <div className="editor-field-list editor-toggle customize-dropdown customize-authoricon">
                  <label className="label-title">Color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('tlsbg')} style={{ background: cnf.tlsbg }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'tlsbg' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.tlsbg} onChange={(e) => handleCnfChange('tlsbg', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }
              {/* for whatsapp chat widget header color */}
              {cnf && cnf.tlshdrbg != undefined &&
                <div className="editor-field-list editor-toggle customize-dropdown customize-authoricon">
                  <label className="label-title">Icon color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('tlshdrbg')} style={{ background: cnf.tlshdrbg }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'tlshdrbg' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.tlshdrbg} onChange={(e) => handleCnfChange('tlshdrbg', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }
              {/* tools icon background color */}
              {fnCheckFieldIsDisplayOrNot('cnf.tlsicnbg', currLayout) && cnf && cnf.tlsicnbg != undefined &&
                <div className="editor-field-list editor-toggle customize-dropdown customize-authoricon">
                  <label className="label-title">Icon color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('tlsicnbg')} style={{ background: cnf.tlsicnbg }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'tlsicnbg' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.tlsicnbg} onChange={(e) => handleCnfChange('tlsicnbg', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }

              {currLayout.ltn != 'whatsapp_chat_1' && cnf && cnf.tlsmmbrbg != undefined &&
                <div className="editor-field-list editor-toggle customize-dropdown customize-authoricon">
                  <label className="label-title">Card color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('tlsmmbrbg')} style={{ background: cnf.tlsmmbrbg }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'tlsmmbrbg' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.tlsmmbrbg} onChange={(e) => handleCnfChange('tlsmmbrbg', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }

              {cnf && cnf.tlstmcuntrbg != undefined &&
                <div className="editor-field-list editor-toggle customize-dropdown customize-authoricon mb-0">
                  <label className="label-title">Timer color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('tlstmcuntrbg')} style={{ background: cnf.tlstmcuntrbg }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'tlstmcuntrbg' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.tlstmcuntrbg} onChange={(e) => handleCnfChange('tlstmcuntrbg', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }

      {/* Rating star color */}
      {(cnf.frmrtngclr != undefined || cnf.frmrtnghvrclr != undefined) &&
        <div className="card card-editor card-template mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Star color</label>
            <div className="customize-list">
              {cnf.frmrtngclr != undefined &&
                <div className="editor-toggle customize-dropdown customize-authoricon title-dataset-select">
                  <label className="label-title">Color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('frmrtngclr')} style={{ background: cnf.frmrtngclr }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'frmrtngclr' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.frmrtngclr} onChange={(e) => handleCnfChange('frmrtngclr', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }
              {cnf.frmrtnghvrclr != undefined &&
                <div className="editor-toggle customize-dropdown customize-authoricon title-dataset-select">
                  <label className="label-title">Hover color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('frmrtnghvrclr')} style={{ background: cnf.frmrtnghvrclr }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'frmrtnghvrclr' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.frmrtnghvrclr} onChange={(e) => handleCnfChange('frmrtnghvrclr', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }

      {/* CTA label */}
      {(cnf.tlsbtnbgclr != undefined || cnf.tlsbtnfntclr != undefined) &&
        <div className="card card-editor card-template mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">CTA label</label>
            <div className="customize-list">
              {cnf.tlsbtnfntclr != undefined &&
                <div className="editor-field-list editor-toggle customize-dropdown customize-ctalabel">
                  <label className="label-title">Font</label>
                  <div className="d-flex editor-cardcmn-fntclr">
                    {cnf.tlsbtnfntsz != undefined &&
                      <div className="editor-dropdown editor-dropdown-sm wg-dd-fntclr mr-3">
                        <Dropdown className="nf-select-dropdown  nf-select-defaultdd" options={fontSize} value={cnf.tlsbtnfntsz ? cnf.tlsbtnfntsz.toString() : cnf.tlsbtnfntsz} onChange={(e) => handleCnfChange('tlsbtnfntsz', e.value)} />
                      </div>
                    }
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('tlsbtnfntclr')} style={{ background: cnf.tlsbtnfntclr }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'tlsbtnfntclr' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.tlsbtnfntclr} onChange={(e) => handleCnfChange('tlsbtnfntclr', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }
              {cnf.tlsbtnbgclr != undefined &&
                <div className="editor-field-list editor-toggle customize-dropdown customize-authoricon mb-0">
                  <label className="label-title">Background color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('tlsbtnbgclr')} style={{ background: cnf.tlsbtnbgclr }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'tlsbtnbgclr' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.tlsbtnbgclr} onChange={(e) => handleCnfChange('tlsbtnbgclr', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }

      {/* border */}
      {cnf && cnf.tlsbrdsz != undefined &&
        <div className="card card-editor card-whats-appearance card-whats-border mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Border</label>
            <div className="customize-list">
              <div className="editor-field-list editor-toggle border-dropdown border-dropdown-clr mb-0">
                <label className="label-title">Color</label>
                <div className="d-flex">
                  <div className={cnf.tlsbrdrd == '0' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('tlsbrdrd', '0')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                      <path id="Path_12730" data-name="Path 12730" d="M2.5,4.167V17.5H4.068V5.735H15.833V4.167Z" transform="translate(-2.5 -4.167)" fill="#90adcc" fillRule="evenodd" />
                    </svg>
                  </div>
                  <div className={cnf.tlsbrdrd == '5' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('tlsbrdrd', '5')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                      <path id="Path_12731" data-name="Path 12731" d="M8.513,4.167A6.013,6.013,0,0,0,2.5,10.006l0,.174V17.5H4.068V10.18A4.445,4.445,0,0,1,8.357,5.738l.156,0h7.32V4.167Z" transform="translate(-2.5 -4.167)" fill="#90adcc" fillRule="evenodd" />
                    </svg>
                  </div>
                  <div className={cnf.tlsbrdrd == '15' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('tlsbrdrd', '15')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                      <path id="Path_12732" data-name="Path 12732" d="M15.049,4.167A12.549,12.549,0,0,0,2.5,16.493l0,.223V17.5H4.068v-.784A10.982,10.982,0,0,1,14.838,5.737l.21,0h.785V4.167Z" transform="translate(-2.5 -4.167)" fill="#90adcc" fillRule="evenodd" />
                    </svg>
                  </div>
                  <div className="colorpicker-box" id="color_code">
                    <div className="colorpicker" onClick={() => handleColorPicker('tlsbrdclr')} style={{ background: cnf.tlsbrdclr }}>
                      <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                        <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                        <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                        <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                      </svg>
                    </div>
                    {
                      colorPick == 'tlsbrdclr' ?
                        <div className="colorPickPopover">
                          <SketchPicker color={cnf.tlsbrdclr} onChange={(e) => handleCnfChange('tlsbrdclr', e.rgb, 'rgb')} />
                        </div>
                        : null
                    }
                  </div>
                </div>
              </div>
              <div className="editor-tworow-part editor-tworow-border pb-0 px-0">
                <div className="editor-tworow-block pb-0">
                  <div className="editor-tworow-col editor-tworow-bdrclr">
                    <label className="label-title">Size</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={brdSizeOption} value={cnf.tlsbrdsz != undefined ? cnf.tlsbrdsz.toString() : cnf.tlsbrdsz} onChange={(e) => handleCnfChange('tlsbrdsz', e.value)} />
                  </div>
                  <div className="editor-tworow-col editor-tworow-bdrsize">
                    <label className="label-title">Style</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={brdStylOption} value={cnf.tlsbrdstl} onChange={(e) => handleCnfChange('tlsbrdstl', e.value)} />
                  </div>
                  <div className="editor-tworow-col editor-tworow-style">
                    <label className="label-title">Radius</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={brdRdsOption} value={cnf.tlsbrdrd != undefined ? cnf.tlsbrdrd.toString() : cnf.tlsbrdrd} onChange={(e) => handleCnfChange('tlsbrdrd', e.value)} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {/* Shadow */}
      {cnf && cnf.tlsshdvl != undefined &&
        <div className="card card-editor card-whats-appearance card-whats-shadows mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Shadow</label>
            <div className="customize-list">
              <div className="editor-field-list editor-toggle border-dropdown border-dropdown-clr mb-0">
                <label className="label-title">Color</label>
                <div className="d-flex">
                  <div className={cnf.tlsshdvl == '0' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('tlsshdnone')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                      <g id="Rectangle_1639" data-name="Rectangle 1639" fill="none" stroke="#90adcc" strokeWidth="1">
                        <rect width="14" height="14" stroke="none" />
                        <rect x="0.5" y="0.5" width="13" height="13" fill="none" />
                      </g>
                    </svg>
                  </div>
                  <div className={cnf.tlsshdvl == '6' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('tlsshdleft')}>
                    <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
                      <defs>
                        <filter id="Path_12735" x="0" y="0" width="16" height="16" filterUnits="userSpaceOnUse">
                          <feOffset dx="2" dy="2" input="SourceAlpha" />
                          <feGaussianBlur result="blur" />
                          <feFlood floodOpacity="0.322" />
                          <feComposite operator="in" in2="blur" />
                          <feComposite in="SourceGraphic" />
                        </filter>
                      </defs>
                      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_12735)">
                        <g id="Path_12735-2" data-name="Path 12735" fill="none">
                          <path d="M0,0H14V14H0Z" stroke="none" />
                          <path d="M 1 1 L 1 13 L 13 13 L 13 1 L 1 1 M 0 0 L 14 0 L 14 14 L 0 14 L 0 0 Z" stroke="none" fill="#90adcc" />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div className={cnf.tlsshdvl == '-6' ? 'squre-rect-item squre-rect-light mr-3 active' : 'squre-rect-item squre-rect-light mr-3'} onClick={() => handleCnfChange('tlsshdright')}>
                    <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16">
                      <defs>
                        <filter id="Path_12736" x="0" y="0" width="16" height="16" filterUnits="userSpaceOnUse">
                          <feOffset dx="-2" dy="-2" input="SourceAlpha" />
                          <feGaussianBlur result="blur" />
                          <feFlood floodOpacity="0.322" />
                          <feComposite operator="in" in2="blur" />
                          <feComposite in="SourceGraphic" />
                        </filter>
                      </defs>
                      <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_12736)">
                        <g id="Path_12736-2" data-name="Path 12736" transform="translate(2 2)" fill="none">
                          <path d="M0,0H14V14H0Z" stroke="none" />
                          <path d="M 1 1 L 1 13 L 13 13 L 13 1 L 1 1 M 0 0 L 14 0 L 14 14 L 0 14 L 0 0 Z" stroke="none" fill="#90adcc" />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div className="colorpicker-box" id="color_code">
                    <div className="colorpicker" onClick={() => handleColorPicker('tlsshdclr')} style={{ background: cnf.tlsshdclr }}>
                      <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                        <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                        <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                        <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                      </svg>
                    </div>
                    {
                      colorPick == 'tlsshdclr' ?
                        <div className="colorPickPopover">
                          <SketchPicker color={cnf.tlsshdclr} onChange={(e) => handleCnfChange('tlsshdclr', e.rgb, 'rgb')} />
                        </div>
                        : null
                    }
                  </div>
                </div>
              </div>
              <div className="editor-tworow-part editor-tworow-border pb-0 px-0">
                <div className="editor-tworow-block pb-0">
                  <div className="editor-tworow-col editor-tworow-bdrclr">
                    <label className="label-title">Shadow-X</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={shdOption} value={cnf.tlsshdhz != undefined ? cnf.tlsshdhz.toString() : cnf.tlsshdhz} onChange={(e) => handleCnfChange('tlsshdhz', e.value)} />
                  </div>
                  <div className="editor-tworow-col editor-tworow-bdrsize">
                    <label className="label-title">Shadow-Y</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={shdOption} value={cnf.tlsshdvl != undefined ? cnf.tlsshdvl.toString() : cnf.tlsshdvl} onChange={(e) => handleCnfChange('tlsshdvl', e.value)} />
                  </div>
                  <div className="editor-tworow-col editor-tworow-style">
                    <label className="label-title">Blur</label>
                    <Dropdown className="nf-select-dropdown nf-select-defaultsm" options={shdblrOption} value={cnf.tlsshdblr != undefined ? cnf.tlsshdblr.toString() : cnf.tlsshdblr} onChange={(e) => handleCnfChange('tlsshdblr', e.value)} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      {cnf && cnf.ckcalwbtntxtclr != undefined &&
        <div className="card card-editor card-template mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Buttons</label>
            <div className="customize-list">
              {cnf.ckcalwbtntxtclr != undefined &&
                <div className="editor-toggle customize-dropdown customize-authoricon editor-field-list">
                  <label className="label-title">Allow button text color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('ckcalwbtntxtclr')} style={{ background: cnf.ckcalwbtntxtclr }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'ckcalwbtntxtclr' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.ckcalwbtntxtclr} onChange={(e) => handleCnfChange('ckcalwbtntxtclr', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }
              {cnf.ckcalwbtnbgclr != undefined &&
                <div className="editor-toggle customize-dropdown customize-authoricon editor-field-list">
                  <label className="label-title">Allow button background color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('ckcalwbtnbgclr')} style={{ background: cnf.ckcalwbtnbgclr }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'ckcalwbtnbgclr' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.ckcalwbtnbgclr} onChange={(e) => handleCnfChange('ckcalwbtnbgclr', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }
              {cnf.ckcdclnbtntxtclr != undefined &&
                <div className="editor-toggle customize-dropdown customize-authoricon editor-field-list">
                  <label className="label-title">Decline button text color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('ckcdclnbtntxtclr')} style={{ background: cnf.ckcdclnbtntxtclr }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'ckcdclnbtntxtclr' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.ckcdclnbtntxtclr} onChange={(e) => handleCnfChange('ckcdclnbtntxtclr', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }
              {cnf.ckcdclnbtnbgclr != undefined &&
                <div className="editor-toggle customize-dropdown customize-authoricon editor-field-list">
                  <label className="label-title">Decline button background color</label>
                  <div className="d-flex">
                    <div className="colorpicker-box" id="color_code">
                      <div className="colorpicker" onClick={() => handleColorPicker('ckcdclnbtnbgclr')} style={{ background: cnf.ckcdclnbtnbgclr }}>
                        <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                          <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                          <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                          <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                        </svg>
                      </div>
                      {
                        colorPick == 'ckcdclnbtnbgclr' ?
                          <div className="colorPickPopover">
                            <SketchPicker color={cnf.ckcdclnbtnbgclr} onChange={(e) => handleCnfChange('ckcdclnbtnbgclr', e.rgb, 'rgb')} />
                          </div>
                          : null
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }
      {cnf && cnf.icss != undefined &&
        <div className="card card-editor card-customize mt-15">
          <div className="card-editor-block p-0 ">
            <label className="card-editor-title">Custom CSS</label>
            <div className="customize-list ">
              <div className="editor-field-list editor-input header-editor-input editor-custom-css">
                <label className="label-title">Custom CSS</label>
                <div className="customize-css-toggle">
                  <label className="switch">
                    <input type="checkbox" checked={cnf.icss} onChange={(e) => handleCnfChange('icss', e.target.checked)} />
                    <span className="slider round"></span>
                  </label>
                </div>
                {cnf && cnf.icss == true &&
                  <textarea className="form-control" rows="4" value={cnf.ccss} onChange={(e) => handleCnfChange('ccss', e.target.value)}></textarea>
                }
              </div>

            </div>
          </div>
        </div>
      }
      {fnCheckFieldIsDisplayOrNot('customize', currLayout) &&
        <div className="card card-editor card-whats-appearance card-whats-other mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Customize</label>
            {wdtnm == 'story_widget' ?
              <div>
                {fnCheckFieldIsDisplayOrNot('cnf.cmntbddn', currLayout) &&
                  <CmnCustomizeCard
                    label={'Tab'}
                    ddnValue={cnf.cmntbddn}
                    ddnField={'cmntbddn'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmntbclr'}
                    clrValue={cnf.cmntbclr} />
                }

                <CmnCustomizeCard
                  label={'Category'}
                  ddnValue={cnf.cmncrdddna}
                  ddnField={'cmncrdddna'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmncrdclra'}
                  clrValue={cnf.cmncrdclra} />

                <CmnCustomizeCard
                  label={'Title'}
                  ddnValue={cnf.cmncrdddnb}
                  ddnField={'cmncrdddnb'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmncrdclrb'}
                  clrValue={cnf.cmncrdclrb} />

                <CmnCustomizeCard
                  label={'Date'}
                  ddnValue={cnf.cmncrdddnd}
                  ddnField={'cmncrdddnd'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmncrdclrd'}
                  clrValue={cnf.cmncrdclrd} />

                <CmnCustomizeCard
                  label={'Description'}
                  ddnValue={cnf.cmncrdddnc}
                  ddnField={'cmncrdddnc'}
                  handleCnfChange={handleCnfChange}
                  handleColorPicker={handleColorPicker}
                  colorPick={colorPick}
                  clrField={'cmncrdclrc'}
                  clrValue={cnf.cmncrdclrc} />
              </div>
              :
              wdtnm == 'tool_slider' ?
                <div>
                  <CmnCustomizeCard
                    label={'Title'}
                    ddnValue={cnf.cmncrdddna}
                    ddnField={'cmncrdddna'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmncrdclra'}
                    clrValue={cnf.cmncrdclra} />

                  <CmnCustomizeCard
                    label={'Description'}
                    ddnValue={cnf.cmncrdddnb}
                    ddnField={'cmncrdddnb'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmncrdclrb'}
                    clrValue={cnf.cmncrdclrb} />

                  <CmnCustomizeCard
                    label={'Date'}
                    ddnValue={cnf.cmncrdddnc}
                    ddnField={'cmncrdddnc'}
                    handleCnfChange={handleCnfChange}
                    handleColorPicker={handleColorPicker}
                    colorPick={colorPick}
                    clrField={'cmncrdclrc'}
                    clrValue={cnf.cmncrdclrc} />
                </div>
                :
                wdtnm == 'whatsappchat' ?
                  <div>
                    <CmnCustomizeCard
                      label={'Header Title'}
                      ddnValue={cnf.cmnhdrddna}
                      ddnField={'cmnhdrddna'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmnhdrclra'}
                      clrValue={cnf.cmnhdrclra} />

                    <CmnCustomizeCard
                      label={'Header Caption'}
                      ddnValue={cnf.cmnhdrddnb}
                      ddnField={'cmnhdrddnb'}
                      handleCnfChange={handleCnfChange}
                      handleColorPicker={handleColorPicker}
                      colorPick={colorPick}
                      clrField={'cmnhdrclrb'}
                      clrValue={cnf.cmnhdrclrb} />
                    {fnCheckFieldIsDisplayOrNot('cnf.cmncrdddna', currLayout) &&
                      <CmnCustomizeCard
                        label={'Member name'}
                        ddnValue={cnf.cmncrdddna}
                        ddnField={'cmncrdddna'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmncrdclra'}
                        clrValue={cnf.cmncrdclra} />
                    }
                    {fnCheckFieldIsDisplayOrNot('cnf.cmncrdddnb', currLayout) &&
                      <CmnCustomizeCard
                        label={'Member designation'}
                        ddnValue={cnf.cmncrdddnb}
                        ddnField={'cmncrdddnb'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmncrdclrb'}
                        clrValue={cnf.cmncrdclrb} />
                    }

                    {fnCheckFieldIsDisplayOrNot('cnf.cmncrdddnc', currLayout) &&
                      <CmnCustomizeCard
                        label={'Welcome message'}
                        ddnValue={cnf.cmncrdddnc}
                        ddnField={'cmncrdddnc'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmncrdclrc'}
                        clrValue={cnf.cmncrdclrc} />
                    }
                    {fnCheckFieldIsDisplayOrNot('cnf.cmncrdddnd', currLayout) &&
                      <CmnCustomizeCard
                        label={'Chat button'}
                        ddnValue={cnf.cmncrdddnd}
                        ddnField={'cmncrdddnd'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmncrdclrd'}
                        clrValue={cnf.cmncrdclrd} />
                    }
                  </div>
                  :
                  wdtnm == 'allinonechat' ?
                    <div>
                      <CmnCustomizeCard
                        label={'Header Title'}
                        ddnValue={cnf.cmnhdrddna}
                        ddnField={'cmnhdrddna'}
                        handleCnfChange={handleCnfChange}
                        handleColorPicker={handleColorPicker}
                        colorPick={colorPick}
                        clrField={'cmnhdrclra'}
                        clrValue={cnf.cmnhdrclra} />

                      {fnCheckFieldIsDisplayOrNot('cnf.cmncrdddna', currLayout) &&
                        <CmnCustomizeCard
                          label={currLayout.ltn == 'allinonechat' ? 'Welcome message' : 'App name'}
                          ddnValue={cnf.cmncrdddna}
                          ddnField={'cmncrdddna'}
                          handleCnfChange={handleCnfChange}
                          handleColorPicker={handleColorPicker}
                          colorPick={colorPick}
                          clrField={'cmncrdclra'}
                          clrValue={cnf.cmncrdclra} />
                      }
                    </div>
                    :
                    wdtnm == 'sales_popup' ?
                      <div>
                        <CmnCustomizeCard
                          label={'Header Title'}
                          ddnValue={cnf.cmnhdrddna}
                          ddnField={'cmnhdrddna'}
                          handleCnfChange={handleCnfChange}
                          handleColorPicker={handleColorPicker}
                          colorPick={colorPick}
                          clrField={'cmnhdrclra'}
                          clrValue={cnf.cmnhdrclra} />

                        <CmnCustomizeCard
                          label={'Header Caption'}
                          ddnValue={cnf.cmnhdrddnb}
                          ddnField={'cmnhdrddnb'}
                          handleCnfChange={handleCnfChange}
                          handleColorPicker={handleColorPicker}
                          colorPick={colorPick}
                          clrField={'cmnhdrclrb'}
                          clrValue={cnf.cmnhdrclrb} />
                      </div>
                      :
                      wdtnm == 'video_popup' ?
                        <div>
                          <CmnCustomizeCard
                            label={'Header Title'}
                            ddnValue={cnf.cmnhdrddna}
                            ddnField={'cmnhdrddna'}
                            handleCnfChange={handleCnfChange}
                            handleColorPicker={handleColorPicker}
                            colorPick={colorPick}
                            clrField={'cmnhdrclra'}
                            clrValue={cnf.cmnhdrclra} />
                        </div>
                        :
                        wdtnm == 'countdown_timer' ?
                          <div>
                            <CmnCustomizeCard
                              label={'Title'}
                              ddnValue={cnf.cmncrdddna}
                              ddnField={'cmncrdddna'}
                              handleCnfChange={handleCnfChange}
                              handleColorPicker={handleColorPicker}
                              colorPick={colorPick}
                              clrField={'cmncrdclra'}
                              clrValue={cnf.cmncrdclra} />

                            <CmnCustomizeCard
                              label={'Days'}
                              ddnValue={cnf.cmncrdddnb}
                              ddnField={'cmncrdddnb'}
                              handleCnfChange={handleCnfChange}
                              handleColorPicker={handleColorPicker}
                              colorPick={colorPick}
                              clrField={'cmncrdclrb'}
                              clrValue={cnf.cmncrdclrb} />

                            <CmnCustomizeCard
                              label={'Hours'}
                              ddnValue={cnf.cmncrdddnc}
                              ddnField={'cmncrdddnc'}
                              handleCnfChange={handleCnfChange}
                              handleColorPicker={handleColorPicker}
                              colorPick={colorPick}
                              clrField={'cmncrdclrc'}
                              clrValue={cnf.cmncrdclrc} />

                            <CmnCustomizeCard
                              label={'Minutes'}
                              ddnValue={cnf.cmncrdddnd}
                              ddnField={'cmncrdddnd'}
                              handleCnfChange={handleCnfChange}
                              handleColorPicker={handleColorPicker}
                              colorPick={colorPick}
                              clrField={'cmncrdclrd'}
                              clrValue={cnf.cmncrdclrd} />

                            <CmnCustomizeCard
                              label={'Seconds'}
                              ddnValue={cnf.cmncrdddne}
                              ddnField={'cmncrdddne'}
                              handleCnfChange={handleCnfChange}
                              handleColorPicker={handleColorPicker}
                              colorPick={colorPick}
                              clrField={'cmncrdclre'}
                              clrValue={cnf.cmncrdclre} />
                            {/* cnf.tlssxtln field not exists then cnf.cmncrdclrf */}
                            {fnCheckFieldIsDisplayOrNot('cnf.tlssxtln', currLayout) &&
                              <CmnCustomizeCard
                                label={'Description'}
                                ddnValue={cnf.cmncrdddnf}
                                ddnField={'cmncrdddnf'}
                                handleCnfChange={handleCnfChange}
                                handleColorPicker={handleColorPicker}
                                colorPick={colorPick}
                                clrField={'cmncrdclrf'}
                                clrValue={cnf.cmncrdclrf} />
                            }
                          </div>
                          :
                          (wdtnm == 'back_to_top' || wdtnm == 'cookie_consent') ?
                            <div>
                              <CmnCustomizeCard
                                label={'Title'}
                                ddnValue={cnf.cmncrdddna}
                                ddnField={'cmncrdddna'}
                                handleCnfChange={handleCnfChange}
                                handleColorPicker={handleColorPicker}
                                colorPick={colorPick}
                                clrField={'cmncrdclra'}
                                clrValue={cnf.cmncrdclra} />
                            </div>
                            :
                            wdtnm == 'review_collector' ?
                              <div>
                                <CmnCustomizeCard
                                  label={'Header Title'}
                                  ddnValue={cnf.cmnhdrddna}
                                  ddnField={'cmnhdrddna'}
                                  handleCnfChange={handleCnfChange}
                                  handleColorPicker={handleColorPicker}
                                  colorPick={colorPick}
                                  clrField={'cmnhdrclra'}
                                  clrValue={cnf.cmnhdrclra} />

                                {
                                  fnCheckFieldIsDisplayOrNot('cnf.tlssndln', currLayout) &&
                                  <CmnCustomizeCard
                                    label={'Button text'}
                                    ddnValue={cnf.cmnhdrddnb}
                                    ddnField={'cmnhdrddnb'}
                                    handleCnfChange={handleCnfChange}
                                    handleColorPicker={handleColorPicker}
                                    colorPick={colorPick}
                                    clrField={'cmnhdrclrb'}
                                    clrValue={cnf.cmnhdrclrb} />
                                }

                                <CmnCustomizeCard
                                  label={'Form label'}
                                  ddnValue={cnf.cmncrdddna}
                                  ddnField={'cmncrdddna'}
                                  handleCnfChange={handleCnfChange}
                                  handleColorPicker={handleColorPicker}
                                  colorPick={colorPick}
                                  clrField={'cmncrdclra'}
                                  clrValue={cnf.cmncrdclra} />

                                <CmnCustomizeCard
                                  label={'Thank you'}
                                  ddnValue={cnf.cmncrdddnb}
                                  ddnField={'cmncrdddnb'}
                                  handleCnfChange={handleCnfChange}
                                  handleColorPicker={handleColorPicker}
                                  colorPick={colorPick}
                                  clrField={'cmncrdclrb'}
                                  clrValue={cnf.cmncrdclrb} />
                              </div>
                              :
                              wdtnm == 'automation_marketing' ?
                                <div>
                                  <CmnCustomizeCard
                                    label={'Title'}
                                    ddnValue={cnf.cmnhdrddna}
                                    ddnField={'cmnhdrddna'}
                                    handleCnfChange={handleCnfChange}
                                    handleColorPicker={handleColorPicker}
                                    colorPick={colorPick}
                                    clrField={'cmnhdrclra'}
                                    clrValue={cnf.cmnhdrclra} />

                                  <CmnCustomizeCard
                                    label={'Caption'}
                                    ddnValue={cnf.cmnhdrddnb}
                                    ddnField={'cmnhdrddnb'}
                                    handleCnfChange={handleCnfChange}
                                    handleColorPicker={handleColorPicker}
                                    colorPick={colorPick}
                                    clrField={'cmnhdrclrb'}
                                    clrValue={cnf.cmnhdrclrb} />

                                  <CmnCustomizeCard
                                    label={'Header Title'}
                                    ddnValue={cnf.cmnhdrddnc}
                                    ddnField={'cmnhdrddnc'}
                                    handleCnfChange={handleCnfChange}
                                    handleColorPicker={handleColorPicker}
                                    colorPick={colorPick}
                                    clrField={'cmnhdrclrc'}
                                    clrValue={cnf.cmnhdrclrc} />

                                  <CmnCustomizeCard
                                    label={'Form label'}
                                    ddnValue={cnf.cmncrdddna}
                                    ddnField={'cmncrdddna'}
                                    handleCnfChange={handleCnfChange}
                                    handleColorPicker={handleColorPicker}
                                    colorPick={colorPick}
                                    clrField={'cmncrdclra'}
                                    clrValue={cnf.cmncrdclra} />

                                  <CmnCustomizeCard
                                    label={'Thank you'}
                                    ddnValue={cnf.cmncrdddnb}
                                    ddnField={'cmncrdddnb'}
                                    handleCnfChange={handleCnfChange}
                                    handleColorPicker={handleColorPicker}
                                    colorPick={colorPick}
                                    clrField={'cmncrdclrb'}
                                    clrValue={cnf.cmncrdclrb} />
                                </div>
                                :
                                wdtnm == 'feedback' ?
                                  <div>
                                    <CmnCustomizeCard
                                      label={'Button text'}
                                      ddnValue={cnf.cmnhdrddna}
                                      ddnField={'cmnhdrddna'}
                                      handleCnfChange={handleCnfChange}
                                      handleColorPicker={handleColorPicker}
                                      colorPick={colorPick}
                                      clrField={'cmnhdrclra'}
                                      clrValue={cnf.cmnhdrclra} />

                                    <CmnCustomizeCard
                                      label={'Header text'}
                                      ddnValue={cnf.cmnhdrddnb}
                                      ddnField={'cmnhdrddnb'}
                                      handleCnfChange={handleCnfChange}
                                      handleColorPicker={handleColorPicker}
                                      colorPick={colorPick}
                                      clrField={'cmnhdrclrb'}
                                      clrValue={cnf.cmnhdrclrb} />

                                    <CmnCustomizeCard
                                      label={'Form Title'}
                                      ddnValue={cnf.cmncrdddna}
                                      ddnField={'cmncrdddna'}
                                      handleCnfChange={handleCnfChange}
                                      handleColorPicker={handleColorPicker}
                                      colorPick={colorPick}
                                      clrField={'cmncrdclra'}
                                      clrValue={cnf.cmncrdclra} />

                                    <CmnCustomizeCard
                                      label={'Next Button'}
                                      ddnValue={cnf.cmncrdddnb}
                                      ddnField={'cmncrdddnb'}
                                      handleCnfChange={handleCnfChange}
                                      handleColorPicker={handleColorPicker}
                                      colorPick={colorPick}
                                      clrField={'cmncrdclrb'}
                                      clrValue={cnf.cmncrdclrb} />

                                    <CmnCustomizeCard
                                      label={'Previous button'}
                                      ddnValue={cnf.cmncrdddnc}
                                      ddnField={'cmncrdddnc'}
                                      handleCnfChange={handleCnfChange}
                                      handleColorPicker={handleColorPicker}
                                      colorPick={colorPick}
                                      clrField={'cmncrdclrc'}
                                      clrValue={cnf.cmncrdclrc} />

                                    <CmnCustomizeCard
                                      label={'Form input label'}
                                      ddnValue={cnf.cmncrdddnd}
                                      ddnField={'cmncrdddnd'}
                                      handleCnfChange={handleCnfChange}
                                      handleColorPicker={handleColorPicker}
                                      colorPick={colorPick}
                                      clrField={'cmncrdclrd'}
                                      clrValue={cnf.cmncrdclrd} />

                                    <CmnCustomizeCard
                                      label={'Thank you'}
                                      ddnValue={cnf.cmncrdddne}
                                      ddnField={'cmncrdddne'}
                                      handleCnfChange={handleCnfChange}
                                      handleColorPicker={handleColorPicker}
                                      colorPick={colorPick}
                                      clrField={'cmncrdclre'}
                                      clrValue={cnf.cmncrdclre} />
                                  </div>
                                  : ''
            }
          </div>
        </div>
      }

      {/* Other */}
      {fnCheckFieldIsDisplayOrNot('other', currLayout) && currLayout.ltn !== 'whatsapp_chat_1' &&
        <div className="card card-editor card-whats-appearance card-whats-other mt-15">
          <div className="card-editor-block p-0">
            <label className="card-editor-title">Other</label>
            {cnf && cnf.iclsicn != undefined &&
              <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                <label className="label-title">Show close icon</label>
                <label className="switch">
                  <input type="checkbox" checked={cnf.iclsicn} onChange={(e) => handleCnfChange('iclsicn', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
            }
            {cnf && cnf.clsicnclr != undefined && cnf.iclsicn == true &&
              <div className="editor-field-list editor-toggle customize-dropdown customize-authoricon">
                <label className="label-title">Close icon color</label>
                <div className="d-flex">
                  <div className="colorpicker-box" id="color_code">
                    <div className="colorpicker" onClick={() => handleColorPicker('clsicnclr')} style={{ background: cnf.clsicnclr }}>
                      <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                        <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                        <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                        <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                      </svg>
                    </div>
                    {
                      colorPick == 'clsicnclr' ?
                        <div className="colorPickPopover">
                          <SketchPicker color={cnf.clsicnclr} onChange={(e) => handleCnfChange('clsicnclr', e.rgb, 'rgb')} />
                        </div>
                        : null
                    }
                  </div>
                </div>
              </div>
            }
            {cnf && cnf.clsotsdclk != undefined &&
              <div className="editor-field-list editor-toggle customize-dropdown customize-showarrow">
                <label className="label-title">Close it if visitors click outside</label>
                <label className="switch">
                  <input type="checkbox" checked={cnf.clsotsdclk} onChange={(e) => handleCnfChange('clsotsdclk', e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>
            }
            <div className="editor-field-list editor-dropdown">
              <label>Font Family</label>
              <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={fontOption} value={cnf.tlsfml} onChange={(e) => handleCnfChange('tlsfml', e.value)} />
            </div>
          </div>
        </div>
      }
      {/* </TabPanel> */}
      {/* {currLayout.ltn == 'whatsapp_chat_3' &&
        <TabPanel className="tabs-secstyle-panel tabs-panel-appearance">
          <div className="card-editor-block p-0 mt-35">
            <label className="card-editor-title">Start chat button</label>
            <div className="customize-list">
              <div className="editor-toggle customize-dropdown customize-authoricon">
                <label className="label-title">Text color</label>
                <div className="d-flex">
                  <div className="colorpicker-box" id="color_code">
                    <div className="colorpicker" onClick={() => handleColorPicker('tlsstctbtntxtclr')} style={{ background: cnf.tlsstctbtntxtclr }}>
                      <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                        <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                        <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                        <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                      </svg>
                    </div>
                    {
                      colorPick == 'tlsstctbtntxtclr' ?
                        <div className="colorPickPopover">
                          <SketchPicker color={cnf.tlsstctbtntxtclr} onChange={(e) => handleCnfChange('tlsstctbtntxtclr', e.rgb, 'rgb')} />
                        </div>
                        : null
                    }
                  </div>
                </div>
              </div>

              <div className="editor-toggle customize-dropdown customize-authoricon">
                <label className="label-title">Background color</label>
                <div className="d-flex">
                  <div className="colorpicker-box" id="color_code">
                    <div className="colorpicker" onClick={() => handleColorPicker('tlsstctbtnbg')} style={{ background: cnf.tlsstctbtnbg }}>
                      <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                        <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                        <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                        <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                      </svg>
                    </div>
                    {
                      colorPick == 'tlsstctbtnbg' ?
                        <div className="colorPickPopover">
                          <SketchPicker color={cnf.tlsstctbtnbg} onChange={(e) => handleCnfChange('tlsstctbtnbg', e.rgb, 'rgb')} />
                        </div>
                        : null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card-editor-block p-0 mt-35">
            <label className="card-editor-title">Welcome screen</label>
            <div className="customize-list">
              <div className="editor-toggle customize-dropdown customize-authoricon">
                <label className="label-title">Text color</label>
                <div className="d-flex">
                  <div className="colorpicker-box" id="color_code">
                    <div className="colorpicker" onClick={() => handleColorPicker('tlswlscrttltxtclr')} style={{ background: cnf.tlswlscrttltxtclr }}>
                      <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                        <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                        <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                        <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                      </svg>
                    </div>
                    {
                      colorPick == 'tlswlscrttltxtclr' ?
                        <div className="colorPickPopover">
                          <SketchPicker color={cnf.tlswlscrttltxtclr} onChange={(e) => handleCnfChange('tlswlscrttltxtclr', e.rgb, 'rgb')} />
                        </div>
                        : null
                    }
                  </div>
                </div>
              </div>

              <div className="editor-toggle customize-dropdown customize-authoricon">
                <label className="label-title">Background color</label>
                <div className="d-flex">
                  <div className="colorpicker-box" id="color_code">
                    <div className="colorpicker" onClick={() => handleColorPicker('tlswlscrbg')} style={{ background: cnf.tlswlscrbg }}>
                      <svg id="eyedropper" xmlns="http://www.w3.org/2000/svg" width="9.511" height="9.512" viewBox="0 0 9.511 9.512">
                        <path id="Path_12717" data-name="Path 12717" d="M201.646,63.334a.279.279,0,0,0-.394,0l-1.015,1.015a.279.279,0,0,0,0,.394l3.046,3.046a.279.279,0,0,0,.394,0l1.015-1.015a.279.279,0,0,0,0-.394Z" transform="translate(-196.437 -62.077)" fill="#fff" />
                        <path id="Path_12718" data-name="Path 12718" d="M327.968.452a1.541,1.541,0,0,0-2.18,0l-.844.844,2.18,2.18.844-.844a1.543,1.543,0,0,0,0-2.18Z" transform="translate(-318.908)" fill="#fff" />
                        <path id="Path_12719" data-name="Path 12719" d="M3.31,191.153a.279.279,0,0,1-.394-.394l1.823-1.823-.893-.893L1.34,190.549a1.544,1.544,0,0,0-.451,1.046l-.555.555a1.121,1.121,0,0,0,1.585,1.585l.555-.555a1.53,1.53,0,0,0,1.046-.451l2.506-2.506-.893-.893Z" transform="translate(-0.007 -184.55)" fill="#fff" />
                      </svg>
                    </div>
                    {
                      colorPick == 'tlswlscrbg' ?
                        <div className="colorPickPopover">
                          <SketchPicker color={cnf.tlswlscrbg} onChange={(e) => handleCnfChange('tlswlscrbg', e.rgb, 'rgb')} />
                        </div>
                        : null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>
      } */}
      {/* </Tabs> */}
    </div>
  );
};

export default ChatAppearanceCard;


// WEBPACK FOOTER //
// ./src/components/Widget/ChatAppearanceCard.js